// src/components/Layout/Sidebar.jsx
import { useState } from "react";
import {
  FaChevronDown,
  FaChevronRight,
  FaUser,
  FaBriefcase,
  FaCheckCircle,
  FaShieldAlt,
  FaUsers,
  FaUserCog,
  FaUserTie,
  FaHandshake,
  FaCashRegister,
  FaHome,
  FaTruck,
  FaClipboardCheck,
} from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import usePermissions from "../../hooks/usePermissions";

const Sidebar = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const [openUser, setOpenUser] = useState(true);
  const [openVerifikasi, setOpenVerifikasi] = useState(true);
  const [openMaster, setOpenMaster] = useState(true);
  const [openManajemen, setOpenManajemen] = useState(true);
  const [openUserSetup, setOpenUserSetup] = useState(false);
  const [openVerifikasiSetup, setOpenVerifikasiSetup] = useState(false);

  const isSuperAdmin = usePermissions("Global").semua;

  const adminPermission = usePermissions("AdminData");
  const employeePermission = usePermissions("EmployeeData");
  const partnerPermission = usePermissions("PartnerData");
  const userSetupPermission = usePermissions("UserSetup");
  const commissionPermission = usePermissions("CommissionData");
  const transactionPermission = usePermissions("CassavaTransactions");

  const menuClass = (path) =>
    `flex items-center gap-2 w-full px-2 py-2 rounded font-medium transition ${
      currentPath === path
        ? "bg-green-600 text-white"
        : "text-green-700 hover:bg-green-600 hover:text-white"
    }`;

  return (
    <aside className="fixed top-16 left-0 h-[calc(100%-4rem)] w-64 bg-white border-r border-green-100 shadow-md p-4 space-y-6 overflow-y-auto z-40 print:hidden">
      {/* === Dashboard === */}
      <ul className="pt-2 space-y-2 border-t border-green-100">
        <li>
          <Link to="/dashboard" className={menuClass("/dashboard")}>
            <FaHome size={18} /> Dashboard
          </Link>
        </li>
      </ul>

      {/* === Data Pengguna === */}
      {(isSuperAdmin ||
        adminPermission.view ||
        employeePermission.view ||
        partnerPermission.view ||
        userSetupPermission.view) && (
        <div>
          <button
            onClick={() => setOpenUser(!openUser)}
            className="flex items-center justify-between w-full px-3 py-2 font-semibold text-green-700 transition rounded-lg hover:bg-green-100 hover:text-green-800"
          >
            <span className="flex items-center gap-3">
              <FaUser size={18} /> Data Pengguna
            </span>
            {openUser ? (
              <FaChevronDown size={14} />
            ) : (
              <FaChevronRight size={14} />
            )}
          </button>

          {openUser && (
            <ul className="pl-6 mt-2 ml-1 space-y-1 border-l-2 border-green-100">
              {adminPermission.view && (
                <li>
                  <Link to="/data-admin" className={menuClass("/data-admin")}>
                    <FaUserCog size={14} /> Data Admin
                  </Link>
                </li>
              )}
              {employeePermission.view && (
                <li>
                  <Link
                    to="/data-karyawan"
                    className={menuClass("/data-karyawan")}
                  >
                    <FaUsers size={14} /> Data Karyawan
                  </Link>
                </li>
              )}
              {partnerPermission.view && (
                <li>
                  <Link to="/data-mitra" className={menuClass("/data-mitra")}>
                    <FaShieldAlt size={14} /> Data Mitra
                  </Link>
                </li>
              )}
              {userSetupPermission.view && (
                <li>
                  <div className="relative">
                    <button
                      onClick={() => setOpenUserSetup(!openUserSetup)}
                      className={`flex items-center justify-between w-full ${menuClass(
                        "/user-setup"
                      )}`}
                    >
                      <span className="flex items-center gap-3">
                        <FaUsers size={14} /> User Setup
                      </span>
                      {openUserSetup ? (
                        <FaChevronDown size={12} />
                      ) : (
                        <FaChevronRight size={12} />
                      )}
                    </button>

                    {openUserSetup && (
                      <ul className="pl-4 mt-1 ml-3 space-y-1 border-l-2 border-green-50">
                        <li>
                          <Link
                            to="/user-setup/admin"
                            className={menuClass("/user-setup/admin")}
                          >
                            <FaUserCog size={12} /> Setup Admin
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/user-setup/karyawan"
                            className={menuClass("/user-setup/karyawan")}
                          >
                            <FaUserTie size={12} /> Setup Karyawan
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/user-setup/mitra"
                            className={menuClass("/user-setup/mitra")}
                          >
                            <FaHandshake size={12} /> Setup Mitra
                          </Link>
                        </li>
                      </ul>
                    )}
                  </div>
                </li>
              )}
            </ul>
          )}
        </div>
      )}
      {/* === Data verifikasi === */}
      {(isSuperAdmin ||
        adminPermission.view ||
        employeePermission.view ||
        partnerPermission.view ||
        userSetupPermission.view) && (
        <div>
          <button
            onClick={() => setOpenVerifikasi(!openVerifikasi)}
            className="flex items-center justify-between w-full px-3 py-2 font-semibold text-green-700 transition rounded-lg hover:bg-green-100 hover:text-green-800"
          >
            <span className="flex items-center gap-3">
              <FaCheckCircle size={18} /> Verifikasi Singkong
            </span>
            {openVerifikasi ? (
              <FaChevronDown size={14} />
            ) : (
              <FaChevronRight size={14} />
            )}
          </button>

          {openVerifikasi && (
            <ul className="pl-6 mt-2 ml-1 space-y-1 border-l-2 border-green-100">
              {adminPermission.view && (
                <li>
                  <Link
                    to="verifikasi/data-angkutan"
                    className={menuClass("verifikasi/data-angkutan")}
                  >
                    <FaTruck size={14} /> Data Angkutan
                  </Link>
                </li>
              )}
              {employeePermission.view && (
                <li>
                  <Link
                    to="/data-karyawan"
                    className={menuClass("/data-karyawan")}
                  >
                    <FaClipboardCheck size={14} />Data Verifikasi
                  </Link>
                </li>
              )}
              {userSetupPermission.view && (
                <li>
                  <div className="relative">
                    <button
                      onClick={() =>
                        setOpenVerifikasiSetup(!openVerifikasiSetup)
                      }
                      className={`flex items-center justify-between w-full ${menuClass(
                        "/user-setup"
                      )}`}
                    >
                      <span className="flex items-center gap-3">
                        <FaUsers size={14} /> Verifikasi Setup
                      </span>
                      {openVerifikasiSetup ? (
                        <FaChevronDown size={12} />
                      ) : (
                        <FaChevronRight size={12} />
                      )}
                    </button>

                    {openVerifikasiSetup && (
                      <ul className="pl-4 mt-1 ml-3 space-y-1 border-l-2 border-green-50">
                        <li>
                          <Link
                            to="verifikasi-setup/supplier"
                            className={menuClass("verifikasi-setup/supplier")}
                          >
                            <FaHandshake size={12} /> Supplier
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="verifikasi-setup/sub-agent-areal"
                            className={menuClass(
                              "verifikasi-setup/sub-agent-areal"
                            )}
                          >
                            <FaUserTie size={12} /> Sub Agent Areal
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="verifikasi-setup/sub-agent-lapak"
                            className={menuClass(
                              "verifikasi-setup/sub-agent-lapak"
                            )}
                          >
                            <FaUserTie size={12} /> Sub Agent Lapak
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="verifikasi-setup/varietas-singkong"
                            className={menuClass(
                              "verifikasi-setup/varietas-singkong"
                            )}
                          >
                            <FaUserTie size={12} /> Varietas Singkong
                          </Link>
                        </li>
                      </ul>
                    )}
                  </div>
                </li>
              )}
            </ul>
          )}
        </div>
      )}

      {(isSuperAdmin || transactionPermission.view) && (
        <ul className="pt-2 space-y-2 border-t border-green-100">
          <li>
            <Link
              to="/anggota-koperasi"
              className={menuClass("/anggota-koperasi")}
            >
              <FaUsers size={18} /> Anggota Koperasi
            </Link>
          </li>
        </ul>
      )}

      {/* === Data Master === */}
      {(isSuperAdmin || commissionPermission.view) && (
        <div>
          <button
            onClick={() => setOpenMaster(!openMaster)}
            className="flex items-center justify-between w-full px-3 py-2 font-semibold text-green-700 transition rounded-lg hover:bg-green-100 hover:text-green-800"
          >
            <span className="flex items-center gap-3">
              <FaBriefcase size={18} /> Data Master
            </span>
            {openMaster ? (
              <FaChevronDown size={14} />
            ) : (
              <FaChevronRight size={14} />
            )}
          </button>
          {openMaster && (
            <ul className="pl-6 mt-2 ml-1 space-y-1 border-l-2 border-green-100">
              <li>
                <Link to="/komisi" className={menuClass("/komisi")}>
                  <FaCheckCircle size={14} /> Data Komisi
                </Link>
              </li>
            </ul>
          )}
        </div>
      )}

      {/* === Manajemen Akses === */}
      {isSuperAdmin && (
        <div>
          <button
            onClick={() => setOpenManajemen(!openManajemen)}
            className="flex items-center justify-between w-full px-3 py-2 font-semibold text-green-700 transition rounded-lg hover:bg-green-100 hover:text-green-800"
          >
            <span className="flex items-center gap-3">
              <FaUser size={18} /> Manajemen Akses
            </span>
            {openManajemen ? (
              <FaChevronDown size={14} />
            ) : (
              <FaChevronRight size={14} />
            )}
          </button>
          {openManajemen && (
            <ul className="pl-6 mt-2 ml-1 space-y-1 border-l-2 border-green-100">
              <li>
                <Link
                  to="/jenis-pengguna"
                  className={menuClass("/jenis-pengguna")}
                >
                  <FaUserCog size={14} /> Jenis Pengguna
                </Link>
              </li>
            </ul>
          )}
        </div>
      )}

      {/* === Transaksi === */}
      {(isSuperAdmin || transactionPermission.view) && (
        <ul className="pt-2 space-y-2 border-t border-green-100">
          <li>
            <Link
              to="/transaksi-singkong"
              className={menuClass("/transaksi-singkong")}
            >
              <FaCashRegister size={18} /> Transaksi Singkong
            </Link>
          </li>
        </ul>
      )}
    </aside>
  );
};

export default Sidebar;
